/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react/prop-types */
import {Fragment, useContext, useState} from 'react'

import {ATOM_ICON_SIZES} from '@s-ui/react-atom-icon'
import AtomSkeleton, {ATOM_SKELETON_VARIANTS} from '@s-ui/react-atom-skeleton'
import Context from '@s-ui/react-context'
import MoleculeAccordion, {
  moleculeAccordionAnimationDuration,
  moleculeAccordionBehavior
} from '@s-ui/react-molecule-accordion'
import DynamicRendering from '@adv-mt/mt-perf-dynamic-rendering'
import IconChevronDown from '@adv-mt/mt-svg-icons/lib/ChevronDown.js'
import IconChevronUp from '@adv-mt/mt-svg-icons/lib/ChevronUp.js'
import TitleBasic, {titleBasicSizes, titleBasicTags} from '@adv-mt/mt-title-basic'

import {ARIA_ATOMIC, ARIA_LIVE, SKELETON, WRAPPER_CLASS_NAME} from '../../../config.js'
import {getItemTotalResults} from '../../../utils.js'
import MakeAccordion from '../MakeAccordion/index.js'

const MakeList = ({aggregations = [], onChange, options, title, value}) => {
  const [openedAccordion, setOpenedAccordion] = useState()

  const {domain} = useContext(Context)

  const config = domain.get('config')
  const {FILTER_NAMES} = config.get('search')

  const makeAggregations = aggregations.find(({filterName}) => filterName === FILTER_NAMES.MAKE) || {}

  const handleChange = (_, {isExpanded, value}) => {
    setOpenedAccordion(isExpanded ? value : '')
  }

  return (
    <MoleculeAccordion
      animationDuration={moleculeAccordionAnimationDuration.NONE}
      as={Fragment}
      behavior={moleculeAccordionBehavior.SINGLE}
      headerIconCollapsed={<IconChevronDown size={ATOM_ICON_SIZES.medium} />}
      headerIconExpanded={<IconChevronUp size={ATOM_ICON_SIZES.medium} />}
      onChange={handleChange}
      values={[...options.map(({id, isOpened}) => isOpened && id), openedAccordion]}
    >
      <div className={`${WRAPPER_CLASS_NAME}OptionGroup`} aria-atomic={ARIA_ATOMIC.TRUE} aria-live={ARIA_LIVE.POLITE}>
        <div className={`${WRAPPER_CLASS_NAME}OptionGroupTitle`}>
          {Boolean(options.length) && <TitleBasic as={titleBasicTags.h2} size={titleBasicSizes.xs} title={title} />}
        </div>
        {options.map(make => (
          <DynamicRendering
            placeholder={<AtomSkeleton height={SKELETON.HEIGHT} variant={ATOM_SKELETON_VARIANTS.round} />}
          >
            <MakeAccordion
              isOpen={openedAccordion === String(make.id) || make.isOpened}
              make={make}
              makeTotalResults={getItemTotalResults({aggregations: makeAggregations.items, itemId: String(make.id)})}
              onChange={onChange}
              value={value.filter(({makeId}) => String(makeId) === String(make.id))}
            />
          </DynamicRendering>
        ))}
      </div>
    </MoleculeAccordion>
  )
}

export default MakeList
